import { Box } from '@mui/material'

import { RouteManager } from '@workwave-tidal/core/icons/logos'

export function ErrorPageHeader() {
  return (
    <Box position="absolute" top={60} left={70}>
      <a href="/">
        <RouteManager width={200} />
      </a>
    </Box>
  )
}
